import { useState, useEffect } from "react";
import { holidayService, Holiday } from "@/services/holidays";

export function useHolidays(year: number, month: number) {
  const [holidays, setHolidays] = useState<Holiday[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadHolidays = async () => {
      setLoading(true);
      setError(null);

      try {
        const holidayData = await holidayService.getHolidaysForMonth(
          year,
          month
        );
        setHolidays(holidayData);
      } catch (err) {
        console.error("Error loading holidays:", err);
        setError("Failed to load holidays");
        setHolidays([]);
      } finally {
        setLoading(false);
      }
    };

    loadHolidays();
  }, [year, month]);

  const isHoliday = (date: string): Holiday | null => {
    return holidays.find((holiday) => holiday.date === date) || null;
  };

  const getHolidayColor = (date: string): string | undefined => {
    const holiday = isHoliday(date);
    return holiday?.color;
  };

  return {
    holidays,
    loading,
    error,
    isHoliday,
    getHolidayColor,
    refresh: () => {
      // Trigger a refresh by changing the dependency
      setHolidays([]);
    },
  };
}
